import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { AccentHeading } from "@/components/AccentHeading";
import { Reveal } from "@/components/Reveal";
import { PillButton } from "@/components/PillButton";
import { scrollToId } from "@/lib/scroll";

export const CinematicCTA = () => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const y = useTransform(scrollYProgress, [0, 1], ["-9%", "9%"]);

  return (
    <section ref={ref} data-testid="cinematic-cta" className="relative h-[70svh] overflow-hidden md:h-[60svh]">
      <motion.img
        style={{ y, scale: 1.18 }}
        src="/images/cta-banner.jpg"
        alt="Luxury residential complex by Godavari Builders at golden hour"
        className="absolute inset-0 h-full w-full object-cover"
      />
      <div className="absolute inset-0" style={{ background: "linear-gradient(180deg, rgba(12,12,12,0.55) 0%, rgba(12,12,12,0.5) 40%, rgba(12,12,12,0.78) 100%)" }} />
      <div className="relative z-10 flex h-full flex-col items-center justify-center text-center container-pad">
        <Reveal>
          <AccentHeading as="h2" text="Start Your Journey to Smarter *Living*" className="block max-w-[18ch] text-4xl leading-[1.05] md:text-6xl" />
        </Reveal>
        <Reveal delay={0.1}>
          <p className="mt-5 max-w-[52ch] text-[var(--text-secondary)]">Discover residences designed around comfort, community, and timeless craftsmanship.</p>
        </Reveal>
        <Reveal delay={0.16}>
          <div className="mt-8">
            <PillButton data-testid="cinematic-cta-button" onClick={() => scrollToId("properties")}>Explore Homes</PillButton>
          </div>
        </Reveal>
      </div>
    </section>
  );
};
